import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import axios from "axios";
import "../../../../App.css";
import OpenAI from "openai";
import {
  Modal,
  Table,
  Button,
  Input,
  Form,
  Row,
  Col,
  Layout,
  Select,
  Checkbox,
  Space,
  Spin,
  Tabs,
  Divider,
  Radio
} from "antd";
import {
  LeftOutlined,
  RightOutlined,
  CheckOutlined,
  CloseOutlined,
  PlusOutlined,
  DeleteFilled,
} from "@ant-design/icons";

import PromptTab from "./PromptTab";
import FinalPrompt from "./FinalPrompt"
import FinalStatement from "./FinalStatement";

const backend = process.env.REACT_APP_BACKEND;
const start = process.env.REACT_APP_VARIABLE_START
const end = process.env.REACT_APP_VARIABLE_END
const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
`;

const openai = new OpenAI({
  apiKey: process.env.REACT_APP_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true 
})


const CreateAISentence = (
  {popup, subUnit, words, reRenderHandler}
  ) => {
    const promptRef = useRef()
    const inputRef = useRef()
    const stopRef = useRef(false)
    // const [rightBox, setRightBox] = useState([true,[]])
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [loading, setLoading] = useState(false);
    const [sourceData, setSourceData] = useState([]);
    const [startEnd, setStartEnd] = useState([0, 0]);
    const [promptData, setPromptData] = useState([])
    const [curTab, setCurTab] = useState("item-1")
    const [gptVersion, setGptVersion] = useState("gpt-3.5-turbo")
    const [count, setCount] = useState(0)
    const [countContinue, setCountContinue] = useState(false)
            
    const [tableParams, setTableParams] = useState({
      pagination: {
        current: 1, // 현재 표시할 페이지
        pageSizeOptions: [10, 50, 100, 200],
        showSizeChanger: true, // pageSize변경옵션을 표시할지 여부
        pageSize: 1000, // 한 페이지에 표시할 레코드 수
        showQuickJumper: true, // page 점프
        hideOnSinglePage: false, //pagenation 자체를 사용하고 싶지 않은 경우 pageSize를 최고로 높이면 됨
      },
      filters: {
        group: "all",
        course: "all",
        stage: "all",
        chapter: "all",
        unit: "all",
        subUnit: "all",
        sentenceStatus: "all",
        errorStatus: "all",
        searchFilter: "",
      },
    });

    const navigate = useNavigate()

    const columns = [
      Table.SELECTION_COLUMN,
      {
      title: "영어문장",
      dataIndex: "sentence_text",
      key: "sentence_text",
      render: (_,record)=>(
        <div>
          <div>{_}</div>
          <div>{record.translate_text}</div>
        </div>
      )
      // width: "max-content",
      // render: (_, record) => (
      //   <Input.TextArea
      //     autoSize
      //     style={{
      //       border: _ === record.sentence_text_origin ? "" : "solid 2px red",
      //     }}
      //     defaultValue={_}
      //     value={_}
      //     onChange={(e) => {
      //       const newText = e.target.value;
      //       const instance = sourceDataKor.slice();
      //       instance[record.num].sentence_text = newText;
      //       instance[record.num].error_status = errorMorpheme(instance[record.num])
      //       setSourceDataKor(instance);
      //     }}
      //     onFocus={() => {
      //       compareRef.current = _;
      //     }}
      //     onBlur={() => {
      //       if (compareRef.current !== _) {
      //         singleChange(_, record, "sentence_text");
      //       }
      //       compareRef.current = null;
      //     }}
      //   ></Input.TextArea>
      // ),
    },
    {
      title: "수준",
      dataIndex: "avg",
      width: 90,
    },
    {
      title: "A0",
      dataIndex: "A0_p",
      width: 90,
      render: (_,record)=>_ ? <div>{(_/record.total*100).toFixed(1)+"%"}</div> : null
    },
    {
      title: "A1",
      dataIndex: "A1_p",
      width: 90,
      render: (_,record)=>_ ? <div>{(_/record.total*100).toFixed(1)+"%"}</div> : null
    },
    {
      title: "A2",
      dataIndex: "A2_p",
      width: 90,
      render: (_,record)=>_ ? <div>{(_/record.total*100).toFixed(1)+"%"}</div> : null
    },
    {
      title: "B1",
      dataIndex: "B1_p",
      width: 90,
      render: (_,record)=>_ ? <div>{(_/record.total*100).toFixed(1)+"%"}</div> : null
    },
    {
      title: "B2",
      dataIndex: "B2_p",
      width: 90,
      render: (_,record)=>_ ? <div>{(_/record.total*100).toFixed(1)+"%"}</div> : null
    },
    {
      title: "C1",
      dataIndex: "C1_p",
      width: 90,
      render: (_,record)=>_ ? <div>{(_/record.total*100).toFixed(1)+"%"}</div> : null
    },
    {
      title: "C2",
      dataIndex: "C2_p",
      width: 90,
      render: (_,record)=>_ ? <div>{(_/record.total*100).toFixed(1)+"%"}</div> : null
    },
    {
      title: "X",
      dataIndex: "X_p",
      width: 90,
      render: (_,record)=>_ ? <div>{(_/record.total*100).toFixed(1)+"%"}</div> : null
    },
    {
      title: "A0",
      dataIndex: "A0",
      // width: 100,
    },
    {
      title: "A1",
      dataIndex: "A1",
      // width: 100,
    },
    {
      title: "A2",
      dataIndex: "A2",
      // width: 100,
    },
    {
      title: "B1",
      dataIndex: "B1",
      // width: 100,
    },
    {
      title: "B2",
      dataIndex: "B2",
      // width: 100,
    },
    {
      title: "C1",
      dataIndex: "C1",
      // width: 100,
    },
    {
      title: "C2",
      dataIndex: "C2",
      // width: 100,
    },
    {
      title: "X",
      dataIndex: "X",
      // width: 100,
    },
    // {}
  ];

  const getGPTData = (data) => {

    const source = data.map((el,idx)=>{
      const cefr = cefrFunction(el.sentence_text)
      
      cefr.id = el.id
      cefr.num = idx
      cefr.translate_text = el.translate_text

      return cefr
    })

    setSourceData(source)
  }

  const cefrFunction = (word) => {
     // 특수문자, 괄호, 점 모두 제거 - 공백은 제거 안함
    // const reg = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gim;
    const reg = /[!?,.\{\}\[\]\\\/]/gim;
    let newWord = word.replace(reg,"").trim()

    const wordArray = newWord.split(" ")
    let cefr = {
      sentence_text: word,
      total:wordArray.length,
      avg:0,
      A0_p:0,
      A1_p:0,
      A2_p:0,
      B1_p:0,
      B2_p:0,
      C1_p:0,
      C2_p:0,
      X_p:0,
      A0:"",
      A1:"",
      A2:"",
      B1:"",
      B2:"",
      C1:"",
      C2:"",
      X:"",
    }
    let sum = 0
    let count = 0
    for(let i=0; i<wordArray.length; i++) {
      let search = false
      for(let n=0; n<words.length; n++) {
        if(wordArray[i].toLowerCase() === words[n].word.toLowerCase()) {
          const cefrLevel = words[n].cefr
          search = true
          cefr[cefrLevel+"_p"] += 1
          if(cefr[cefrLevel] === "") {
            cefr[cefrLevel] += wordArray[i]
          } else {
            cefr[cefrLevel] += ", "+wordArray[i]
          }
          
          switch (cefrLevel) {
            case "A0":
              sum += 1
              count += 1
              break;
            case "A1":
              sum += 2
              count += 1
              break
            case "A2":
              sum += 3
              count += 1
              break
            case "B1":
              sum += 4
              count += 1
              break
            case "B2":
              sum += 5
              count += 1
              break
            case "C1":
              sum += 6
              count += 1
              break
            case "C2":
              sum += 7
              count += 1
              break
            
            default:
              sum +=0
          }


          break;
        }
      }
      if(!search) {
        cefr.X_p += 1
        if(cefr.X === "") {
          cefr.X += wordArray[i]
        } else {
          cefr.X += ", "+wordArray[i]
        }
      }
    }

    const levelArray = (sum / count).toFixed(2).split(".")

    switch (levelArray[0]) {
      case "1":
        cefr.avg = "A0."+levelArray[1]
        break
      case "2":
        cefr.avg = "A1."+levelArray[1]
        break
      case "3":
        cefr.avg = "A2."+levelArray[1]
        break
      case "4":
        cefr.avg = "B1."+levelArray[1]
        break
      case "5":
        cefr.avg = "B2."+levelArray[1]
        break
      case "6":
        cefr.avg = "C1."+levelArray[1]
        break
      case "7":
        cefr.avg = "C2."+levelArray[1]
        break

      default:
        cefr.avg = "측정불가"
    }
    

    return cefr
  }

  const getDataSource = (data) => {
    const source = data.map(el=>{
      const text = el.statement_text

      let variableArray = []
      let textArray = []
      let variableUseYnArray = []

      const variableF = (text) =>{
        // const text = String(textValue)
        if(text === null || text === undefined) return
        const a = text.indexOf(start)
        let b = -1

        // 어느 위치의 변수가 빠졌는지 확인하는 재귀함수
        const bFunction = (text) => {
          if(text.indexOf(end) === -1) return
          if(text.indexOf(end) > a) {
            b=text.indexOf(end)
            return
          }
          const subText = text.replace(end,"a")
          bFunction(subText)
        }
        bFunction(text)

        // const b = text.indexOf(end)
        if(a === -1 || b === -1) {
          textArray.push(text)
          return
        }
        const variableText = text.substring(a+1,b) // 변수
        const preText = text.slice(0,a) // 변수 전의 텍스트
        variableArray.push(variableText)
        variableUseYnArray.push("Y")
        textArray.push(preText)
        const nextText = text.slice(b+1) // 변수 후의 나머지 텍스트
        variableF(nextText)
      }
      variableF(text)
      
      el.useYn = "Y"
      el.statement_variable_useyn = variableUseYnArray
      el.statement_variable_array = variableArray
      el.statement_text_array = textArray
      el.variableArray = el.variable_default_value?.split(",").map(el=>el.trim()) || []
      el.prompt_text = el.statement_variable_array.length === 0 ? (el.statement_text && el.statement_text) : promptFuntion(el)
      return el
    })
    setPromptData(source)
  }

  const getDataSource2 = (data) => {
    const prompt = data[0]
    const condition = data[1]

    const source = prompt.map((el,idx)=>{
      const text = el.statement_text
      const conditionArray = condition.filter(ele=>ele.ContentSettingLatestGPTPromptCondition_id === el.id)

      let textArray = []

      const variableF = (text) =>{
        if(text === null || text === undefined) return

        const a = text.indexOf(start)
        let b = -1

        // 어느 위치의 변수가 빠졌는지 확인하는 재귀함수
        const bFunction = (text) => {
          if(text.indexOf(end) === -1) return
          if(text.indexOf(end) > a) {
            b=text.indexOf(end)
            return
          }
          const subText = text.replace(end,"a")
          bFunction(subText)
        }
        bFunction(text)

        // const b = text.indexOf(end)
        if(a === -1 || b === -1) {
          textArray.push(text)
          return
        }
        
        const preText = text.slice(0,a) // 변수 전의 텍스트
        textArray.push(preText)
        const nextText = text.slice(b+1) // 변수 후의 나머지 텍스트
        variableF(nextText)
      }
      variableF(text)
      
      el.useYn = el.use_yn
      el.statement_variable_useyn = conditionArray.map(el=>el.use_yn)
      el.statement_variable_array = conditionArray.map(el=>el.variable_name)
      el.statement_text_array = textArray
      el.variableArray = conditionArray.map(el=>el.variable_value)

      el.prompt_text = el.statement_variable_array.length === 0 ? (el.statement_text && el.statement_text) : promptFuntion(el)

      return el
    })
    setPromptData(source)
  }

  const items = [
    {
      label: "신규 프롬프트 생성", 
      key: "item-1", 
      children:
        <PromptTab 
          ref={promptRef} 
          promptData={promptData}
          promptDataChangeHandler={promptDataChangeHandler}
          promptDataChangeHandlerAll={promptDataChangeHandlerAll}
          promptDataChangeHandlerAll2={promptDataChangeHandlerAll2}
          getDataSource={getDataSource}
        />
    },
    {
      label: "마지막으로 저장된 조건",
      key: "item-2", 
      children:
        <FinalStatement
          ref={promptRef} 
          promptData={promptData}
          promptDataChangeHandler={promptDataChangeHandler}
          promptDataChangeHandlerAll={promptDataChangeHandlerAll}
          promptDataChangeHandlerAll2={promptDataChangeHandlerAll2}
          getDataSource={getDataSource}
        />
    },
    {label: "마지막으로 저장된 프롬프트", 
      key: "item-3",
      children:
        <FinalPrompt
          ref={promptRef}
          subUnit={subUnit}
        />
    },
  ]

  const reRenderData = (data) => {
    const newData = data.map(el=>{
      el.prompt_text = el.statement_variable_array.length === 0 ? (el.statement_text && el.statement_text) : promptFuntion(el)
      return el
    })
    setPromptData(newData)
  }

  const promptFuntion = (el) => {
    let prompt = ""
    for(let i=0; i<el.statement_variable_array.length; i++){
      prompt = prompt + el.statement_text_array[i] + (el.statement_variable_useyn[i] === "Y" ? (el.variableArray[i] || `${start}${el.statement_variable_array[i] || ""}${end}`) : `${start}${el.statement_variable_array[i] || ""}${end}`)
    }
    if(el.statement_variable_array.length < el.statement_text_array.length) {
      prompt += el.statement_text_array[el.statement_variable_array.length]
    }
    return prompt
  }

  function promptDataChangeHandler (data) {    
    const newData = data.map(el=>{
      el.prompt_text = el.statement_variable_array.length === 0 ? (el.statement_text && el.statement_text) : promptFuntion(el)
      return el
    })
    setPromptData(newData)

  }
  
  function promptDataChangeHandlerAll (data) {    
    const newData = data.map(el=>{
      const text = el.statement_text
      let variableArray = []
      let textArray = []

      //배치할 텍스트와 변수를 배열로 정렬하는 재귀함수
      const variableF = (text) =>{
        // const text = String(textValue)
        if(text === null || text === undefined) return
        const a = text.indexOf(start)
        let b = -1

        // 어느 위치의 변수가 빠졌는지 확인하는 재귀함수
        const bFunction = (text) => {
          if(text.indexOf(end) === -1) return
          if(text.indexOf(end) > a) {
            b=text.indexOf(end)
            return
          }
          const subText = text.replace(end,"a")
          bFunction(subText)
        }
        bFunction(text)

        // const b = text.indexOf(end)
        if(a === -1 || b === -1) {
          textArray.push(text)
          return
        }

        const variableText = text.substring(a+1,b) // 변수
        const preText = text.slice(0,a) // 변수 전의 텍스트
        variableArray.push(variableText)
        // variableUseYnArray.push("Y")
        textArray.push(preText)
        const nextText = text.slice(b+1) // 변수 후의 나머지 텍스트
        variableF(nextText)
      }
      variableF(text)

      const big = Math.max(el.statement_variable_array.length, variableArray.length)
      
      if(el.statement_variable_array.length > variableArray.length) { // 변수가 제외되는 경우
        const a = JSON.parse(JSON.stringify(el.statement_variable_array))
        const b = JSON.parse(JSON.stringify(variableArray))
        for (let i=0; i<big; i++) {
          if(a[i] === b[i]) {
            continue;
          } else {
            b.splice(i,0,"")
            el.variableArray.splice(i,1)
            el.statement_variable_useyn.splice(i,1)
          }
        }
      } else if(el.statement_variable_array.length < variableArray.length) { // 변수가 추가되는 경우
        const a = JSON.parse(JSON.stringify(el.statement_variable_array))
        const b = JSON.parse(JSON.stringify(variableArray))
        for (let i=0; i<big; i++) {
          if(a[i] === b[i]) {
            continue;
          } else {
            a.splice(i,0,"")
            el.variableArray.splice(i,0,"")
            el.statement_variable_useyn.splice(i,0,"Y")
          }
        }
      }

      el.statement_variable_array = variableArray
      el.statement_text_array = textArray

      el.prompt_text = el.statement_variable_array.length === 0 ? (el.statement_text && el.statement_text) : promptFuntion(el)
      return el
    })
    setPromptData(newData)

  }
  function promptDataChangeHandlerAll2 (data, num) {    
    
    const source = data.map((el,idx)=>{
      if(idx !== num) return el
      const text = el.statement_text

      let variableArray = []
      let textArray = []
      let variableUseYnArray = []

      const variableF = (text) =>{
        // const text = String(textValue)
        if(text === null || text === undefined) return
        const a = text.indexOf(start)
        const b = text.indexOf(end)
        if(a === -1 || b === -1) {
          textArray.push(text)
          return
        }
        const variableText = text.substring(a+1,b) // 변수
        const preText = text.slice(0,a) // 변수 전의 텍스트
        variableArray.push(variableText)
        variableUseYnArray.push("Y")
        textArray.push(preText)
        const nextText = text.slice(b+1) // 변수 후의 나머지 텍스트
        variableF(nextText)
      }
      variableF(text)
      
      el.useYn = "Y"
      el.statement_variable_useyn = variableUseYnArray
      el.statement_variable_array = variableArray
      el.statement_text_array = textArray
      el.variableArray = el.variable_default_value?.split(",").map(el=>el.trim()) || []
      el.prompt_text = el.statement_variable_array.length === 0 ? (el.statement_text && el.statement_text) : promptFuntion(el)
      return el
    })
    setPromptData(source)
  }

    const createSentence = async () => {
    const subunitCode = subUnit.value
    const prompt_text = promptRef.current.getFieldValue("prompt_text")
    if(!prompt_text) {
      Modal.error({
        title:"에러",
        content: "프롬프트 문장이 없습니다.",
        okText:"확인",
      })
    } else {
      setLoading(true)
      setCountContinue(true) // 카운트 진행 시작

      axios
      .post(`${backend}/contents/content_sentence/ai/gpt`,{gptVersion, prompt_text, subunitCode})
      .then(res=>{
        const data = res.data.data
        console.log(res.data.originData)
        getGPTData(data)
        setLoading(false)
        setCountContinue(false) // 카운트 진행 종료
      })
      .catch(err=>{
        console.log(err);
        setLoading(false)
        setCountContinue(false) // 카운트 진행 종료
        if(err.response && err.response.status===401) {
          navigate("/auth")
        } else {
          Modal.error({
            title:"AI 문장생성 오류",
            content: err.response?.data.message,
            okText:"확인"
          })
        }
      })
    }
  }

  const stopCreateSentence = () => {
    setLoading(false)
    setCountContinue(false)
    stopRef.current = true
    // 문장생성을 중지 시 sdk및 api에 대한 중지가 어려운 관계로 정상적인 답변을 받아도 db에 저장되지 않도록 조치하는 것으로 종료한다.
  }

  const createSentenceBySDK = async () => {
    stopRef.current=false
    const subUnitCode = subUnit.value
    const prompt_text = promptRef.current.getFieldValue("prompt_text")
    if(!prompt_text) {
        Modal.error({
            title:"에러",
            content: "프롬프트 문장이 없습니다.",
            okText:"확인",
        })
    } else {
      setLoading(true)
      setCountContinue(true) // 카운트 진행 시작
      try{
        const chatCompletion = await openai.chat.completions.create({
          model: gptVersion,
          temperature: 1,
          messages: 
            [
              // {
              //   "role": "system",
              //   "content": "List only sentences in array format"
              // },
              {
                "role": "user",
                "content": prompt_text
              },
            ],
          tools: [
            {
              "type": "function",
              "function": {
                "name": "get_sentence",
                "description": "get english and korean sentences",
                "parameters": {
                    "type": "object",
                    "properties": {
                        "props": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "english": { "type": "string", "description": "english sentence" },
                                    // "english pronunciation": { "type": "string", "description": "Write the pronunciation for each sentence according to the IPA pronunciation guide" },
                                    // "korean pronunciation": { "type": "string", "description": "Write a Korean pronunciation guide for the IPA pronunciation guide" },
                                    "korean": { "type": "string", "description": "english to korean" },
                                }
                            }
                        }
                    },
                    "required": ["props"]
                    }
              },
          }
          ]
        });
        
        if(!stopRef.current) {
          if (!chatCompletion.choices[0]?.message?.tool_calls) {
            console.log("tool_calls가 없습니다.", chatCompletion)
          }
          
          const newSentence = JSON.parse(chatCompletion.choices[0]?.message.tool_calls[0]?.function.arguments).props
          console.log("Generated by " + chatCompletion.model + " at " + subUnitCode)
          console.log(newSentence)

          axios.post(`${backend}/contents/content_sentence/ai/gpt/list2/${subUnitCode}`,{newSentence})
          .then(res=>{
            getGPTData(res.data.data)
            setLoading(false)
            setCountContinue(false) // 카운트 진행 종료
          })
          .catch(err=>{
            setLoading(false)
            setCountContinue(false) // 카운트 진행 종료
            Modal.error({
              title:"DB저장 에러",
              okText:"확인",
              content:"DB에 저장하지 못했습니다. 관리자에게 문의하세요."
            })
          })
        }
      } catch (error) {
        if (error instanceof OpenAI.APIError) {
          console.error(error.status);  // e.g. 401
          console.error(error.message); // e.g. The authentication token you passed was invalid...
          console.error(error.code);  // e.g. 'invalid_api_key'
          console.error(error.type);  // e.g. 'invalid_request_error'

          Modal.error({
            title:"에러",
            content:"GPT 에러로 문장을 생성하지 못했습니다. console을 확인하세요.",
            okText:"확인"
          })
          setLoading(false)
          setCountContinue(false) // 카운트 진행 종료
        } else {
          // Non-API error
          console.log(error);
          Modal.error({
            title:"에러",
            content:"원인이 불명한 에러(대부분은 GPT답변 형식오류)로 문장을 생성하지 못했습니다. console을 확인하세요.",
            okText:"확인"
          })
          setLoading(false)
          setCountContinue(false) // 카운트 진행 종료
        }
      }
    }
  }
  
  const promptConditionSaveHandler = () => {
    const subunitCode = subUnit.value
    
    axios
    .post(`${backend}/contents/content_sentence/ai/gpt/statement/${subunitCode}`,{promptData})
    .then(res=>{
      Modal.success({
        title:"저장완료",
        okText:"확인",
      })
    })
    .catch(err=>{
      console.log(err);
      if(err.response && err.response.status===401) {
        navigate("/auth")
      }
    })
  }



  const promptSentenceSaveHandler = () =>{
    const subunitCode = subUnit.value
    const promptSentence = promptRef.current.getFieldValue("prompt_text")
    
    axios
      .post(`${backend}/contents/content_sentence/ai/gpt/prompt/${subunitCode}`,{promptSentence})
      .then(res=>{
        Modal.success({
          title:"저장완료",
          okText:"확인",
        })
      })
      .catch(err=>{
        console.log(err);
        if(err.response && err.response.status===401) {
          navigate("/auth")
        }
      })
  }

  const sentenceInputHandler = () => {
    const newSentence = inputRef.current.getFieldValue("sentenceInput")
    const subUnitCode = subUnit.value

    if(!newSentence) {
      Modal.error({
        title: "에러",
        content:"추가할 문장을 입력하세요.",
        okText:"확인"
      })
    } else {
      axios
      .post(`${backend}/contents/content_sentence/ai/gpt/list/${subUnitCode}`,{newSentence})
      .then(res=>{
        inputRef.current.resetFields()
        getGPTData(res.data.data)
      })
      .catch(err=>{
        console.log(err);
        if(err.response && err.response.status===401) {
          navigate("/auth")
        }
      })
    }
  }

  const tabChange = (_) => {
    setCurTab(_)
  }
 // AI 문장추가에서 삭제 기능
  const deleteSentenceHandler = () => {
    if(!selectedKeys.length) {
      Modal.error({
        title:"선택에러",
        content: "문장을 선택한 후 진행하세요.",
        okText:"확인"
      })
    } else {
      const subUnitCode = subUnit.value
  
      axios
      .delete(`${backend}/contents/content_sentence/ai/gpt/list/${subUnitCode}/${selectedKeys}`)
      .then(res=>{
        getGPTData(res.data.data)
        setSelectedKeys([])
        setSelectedRows([])
      })
      .catch(err=>{
        console.log(err);
        if(err.response && err.response.status===401) {
          navigate("/auth")
        }
      })
    }
  }

  const saveSentenceHandler = () => {
    if(!selectedKeys.length) {
      Modal.error({
        title:"선택에러",
        content: "문장을 선택한 후 진행하세요.",
        okText:"확인"
      })
    } else {
      const subUnitCode = subUnit.value
      const values = selectedRows.map(el=>{
        const ele = 
          {
            sentence_text: el.sentence_text,
            translate_text: el.translate_text
          }
        return ele
      })

      axios
        .post(`${backend}/contents/content_sentence/sentence/gpt`, {
          values, subUnitCode
        })
        .then(res=>{
          reRenderHandler()
          Modal.success({
            title: "저장 성공",
            content: "해당 서브유닛 DB에 성공적으로 저장했습니다.\n해당 문장은 삭제를 진행합니다.",
            okText: "확인",
            onOk: ()=>deleteSentenceHandler()
          })
        })
        .catch(err=>{
          console.log(err);
          if(err.response && err.response.status===401) {
            navigate("/auth")
          }
        })
    }
  }

  const gtpVersionChangeHandler = (e) => {
    const subUnitCode = subUnit.value
    const gptVersionValue = e.target.value
    setGptVersion(gptVersionValue)
    axios
    .post(`${backend}/contents/content_sentence/ai/gpt/version/${subUnitCode}`,{gptVersionValue})
    .catch(err=>{
      console.log(err);
      if(err.response && err.response.status===401) {
        navigate("/auth")
      }
    })
  }

  useEffect(()=>{
    return ()=>{
      setLoading(false)
      setCountContinue(false) // 카운트 진행 종료
    }
  },[])

  useEffect(() => {
    if (countContinue) {
      const codeTime = setInterval(() => {
        setCount(count + 1);
      }, 1000);
      return () => {
        clearInterval(codeTime);
      };
    } else {
      setCount(0);
    }
  });

  useEffect(()=>{
    axios
      .get(`${backend}/contents/content_sentence/ai/gpt/list/${subUnit.value}`)
      .then(res=>{
        if(res.data.data[1][0]) {
          setGptVersion(res.data.data[1][0].model)
        }
        getGPTData(res.data.data[0])
      })
      .catch(err=>{
        console.log(err);
        if (err.response.status === 401) {
          navigate("/auth");
        }
      })
  },[])

  useEffect(()=>{
    if(curTab === "item-1") {
      axios
      .get(`${backend}/contents/content_sentence/ai/gpt/prompt`)
      .then(res=>{
        // console.log(res)
        getDataSource(res.data.data[1])
      })
      .catch(err=>{
        console.log(err);
        if (err.response.status === 401) {
          navigate("/auth");
        }
      })
    } else if(curTab === "item-2") {
      const subunitCode = subUnit.value
      axios
      .get(`${backend}/contents/content_sentence/ai/gpt/prompt/${subunitCode}`)
      .then(res=>{
        getDataSource2(res.data.data)
        // console.log(res)
      })
      .catch(err=>{
        console.log(err);
        if (err.response.status === 401) {
          navigate("/auth");
        }
      })
    }
  },[curTab])

  return (
    <Spin 
      spinning={loading} 
      tip=
        {
          <>
            <div>{`${gptVersion} (으)로 작업 중..${count}초 경과`}</div>
            <Button onClick={stopCreateSentence} disabled>중지</Button>
          </>
        }
    >
      <div style={{display:"flex", height:"76vh"}}>
        <div style={{display:"flex", width:"500px", height:"100%", flexShrink:0, flexDirection:"column"}}>
          <div style={{overflowY:"auto"}}>
            <Space direction="vertical" style={{width:"100%", marginBottom:10}}>
              <div style={{textAlign:"left"}}>서브유닛</div>
              <Input disabled value={subUnit.label}></Input>
            </Space>
            <Tabs
              defaultActiveKey="item-1"
              destroyInactiveTabPane={true}
              type="line"
              size="small"
              items={items}
              onChange={(_)=>tabChange(_)}
            ></Tabs>
            <Divider />
          </div>

          <div style={{height:"50px", paddingTop:"5px", flexShrink:0, display: "flex", justifyContent:"end" }}>
          <Radio.Group onChange={(e)=>gtpVersionChangeHandler(e)} value={gptVersion} style={{textAlign:"left"}}>
            <Radio style={{fontSize:"11px"}} value={"gpt-3.5-turbo"}>gpt-3.5-turbo</Radio>
            <Radio style={{fontSize:"11px"}} value={"gpt-4"}>gpt-4</Radio>
          </Radio.Group>
            <Button
              type="primary"
              style={{marginRight:"10px"}}
              // onClick={createSentence} // 백엔드에서 api를 통한 gpt 생성
              onClick={createSentenceBySDK} // 클라이언트에서 sdk를 통한 GPT생성
            >
              문장생성
            </Button>
            <Button
              style={{marginRight:"10px"}}
              hidden={curTab === "item-3" ? true : false}
              onClick={promptConditionSaveHandler}
            >
              조건저장
            </Button>
            <Button
              style={{marginRight:"10px"}}
              onClick={promptSentenceSaveHandler} 
            >
              프롬프트 문장 저장
            </Button>
            <Button
              onClick={()=>{popup(false)}} 
            >
              닫기
            </Button>
          </div>
        </div>

        <div style={{display:"flex", flexDirection:"column",width:"100%", padding:"30px 0px 0px 20px", overflowX:"auto"}}>

          <StyledTable
            className="aiPageTable"
            rowSelection={{
              selectedRowKeys: selectedKeys,
              onChange: (keys, rows) => {
                setStartEnd([0, rows.length - 1]);
                setSelectedRows(rows.sort((a, b) => a.num - b.num));
                setSelectedKeys(keys.sort((a, b) => a - b));
              },
            }}
            columns={columns}
            rowKey="id"
            dataSource={sourceData}
            loading={loading}
            pagination={false}
            // onChange={handleTableChange}
            footer={() => (
              <div style={{ textAlign: "left" }}>
                <Space>
                  <Button onClick={deleteSentenceHandler}>
                    선택문장 삭제
                  </Button>
                  <Button onClick={saveSentenceHandler}>
                    선택문장 저장
                  </Button>
                </Space>
              </div>
            )}
            scroll={{ x:"max-content", y:"50vh"}}
          />

          <Space direction="vertical" style={{ height:100, flexShrink:0, width:"100%" , textAlign:"left"}}>
            <Form ref={inputRef}>
              <Form.Item name="sentenceInput" style={{marginBottom:"0px"}}>
                <Input.TextArea autoSize/>
              </Form.Item>
            </Form>
            <Button size="small" onClick={sentenceInputHandler}>입력한 문장을 목록에 추가하기</Button>
          </Space>
        </div>
      </div>
    </Spin>
  )
};
export default CreateAISentence;